import { CreditCardDetailsModule } from '@/components/modules/CreditCard/Detail/CardConfiguration/CreditCardDetails';
import { CreditCardDocumentationModule } from '@/components/modules/CreditCard/Detail/Documentation/CreditCardDocumentation';
import { CreditCardOnboardingDetailsModule } from '@/components/modules/CreditCard/Detail/OnboardingDetails/CreditCardOnboardingDetails';
import { CreditCardOverviewModule } from '@/components/modules/CreditCard/Detail/Overview/CreditCardOverview';
// import { PaymentPlanModule } from '@/components/modules/PaymentPlan/PaymentPlan';
import { DYNAMIC_PAGE_PATHS } from '@/components/views/DynamicPageView/config/shared/pathRoutes';
import { WIDGETS } from '@/components/views/DynamicPageView/config/shared/widgets';
import { ALL_CORE_APP_ROLES, ALL_CORE_APP_USER_TYPES, APP_ROLES, APP_USER_TYPES } from '@/config/config';
import { ApplicationType, PageScheme } from '@/config/types';

export const PAGE_CREDIT_CARD: PageScheme = {
  path: DYNAMIC_PAGE_PATHS.CREDIT_CARD,
  showIfAllowedProduct: ApplicationType.CARD,
  schemesByRoles: [
    {
      roles: [...ALL_CORE_APP_ROLES],
      titleTextId: 'CREDIT_CARD_DETAIL',
      widgets: [
        { id: WIDGETS.CREDIT_CARD_PARTICIPANT_SOURCE_WIDGET, roles: [...ALL_CORE_APP_ROLES], props: {} },
        { id: WIDGETS.CREDIT_CARD_PAGE_TITLE, roles: [...ALL_CORE_APP_ROLES], props: {}, notShownInRightMenu: true },
        { id: WIDGETS.CUSTOMER_SUPPORT, roles: [APP_ROLES.ADMIN, APP_ROLES.SUPER_ADMIN], props: {} },
        {
          id: WIDGETS.NOTIFICATIONS_WIDGET,
          roles: [APP_ROLES.SUPER_ADMIN, APP_ROLES.ADMIN, APP_ROLES.LENDER],
          props: {},
        },
        {
          id: WIDGETS.OPEN_APPLICATION,
          roles: [
            APP_ROLES.SUPER_ADMIN,
            APP_ROLES.ADMIN,
            APP_ROLES.MERCHANT,
            APP_ROLES.MERCHANT_GROUP,
            APP_ROLES.CHANNEL,
            APP_ROLES.AGENT,
            APP_ROLES.PARTNER,
            APP_ROLES.LENDER,
          ],
          props: { application: ApplicationType.CARD },
        },
      ],
    },
  ],
  sections: [
    {
      textId: 'CREDIT_CARD_OVERVIEW',
      module: (
        <CreditCardOverviewModule
          permissions={{
            view: ALL_CORE_APP_USER_TYPES,
            edit: [],
          }}
        />
      ),
    },
    {
      textId: 'CREDIT_CARD_DETAILS',
      module: (
        <CreditCardDetailsModule
          permissions={{
            view: [
              APP_USER_TYPES.SUPER_ADMIN,
              APP_USER_TYPES.ADMIN,
              APP_USER_TYPES.MERCHANT_GROUP,
              APP_USER_TYPES.MERCHANT,
              APP_USER_TYPES.CHANNEL,
              APP_USER_TYPES.AGENT,
              APP_USER_TYPES.PARTNER,
              APP_USER_TYPES.LENDER,
            ],
            edit: [],
          }}
        />
      ),
    },
    {
      textId: 'APPLICATION_PROCESS',
      module: (
        <CreditCardOnboardingDetailsModule
          permissions={{
            view: [
              APP_USER_TYPES.SUPER_ADMIN,
              APP_USER_TYPES.ADMIN,
              APP_USER_TYPES.MERCHANT_GROUP,
              APP_USER_TYPES.MERCHANT,
              APP_USER_TYPES.CHANNEL,
              APP_USER_TYPES.AGENT,
              APP_USER_TYPES.PARTNER,
              APP_USER_TYPES.LENDER,
            ],
            edit: [],
          }}
        />
      ),
    },
    {
      textId: 'DOCUMENTATION',
      module: (
        <CreditCardDocumentationModule
          permissions={{
            view: [
              APP_USER_TYPES.SUPER_ADMIN,
              APP_USER_TYPES.ADMIN,
              APP_USER_TYPES.LENDER,
              APP_USER_TYPES.MERCHANT_GROUP,
              APP_USER_TYPES.MERCHANT,
              APP_USER_TYPES.CHANNEL,
              APP_USER_TYPES.AGENT,
            ],
            edit: [
              APP_ROLES.SUPER_ADMIN,
              APP_ROLES.ADMIN,
              APP_ROLES.LENDER,
              APP_ROLES.MERCHANT,
              APP_ROLES.CHANNEL,
              APP_ROLES.AGENT,
              APP_ROLES.PARTNER,
            ],
          }}
        />
      ),
    },
  ],
};
